import { APP_INITIALIZER, ErrorHandler, NgModule, Provider } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { LoginComponent, LoginModule } from '@clavisco/login';

import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { UrlInterceptor } from './interceptors/url.interceptor';
import { SharedModule } from './shared/shared.module';
import { AlertsModule, AlertsService } from '@clavisco/alerts';
import { HeadersInterceptor } from './interceptors/headers.interceptor';
import { LinkerService } from '@clavisco/linker';
import { Miscellaneous } from '@clavisco/core';
import { ErrorInterceptor } from './interceptors/error.interceptor';
import { OverlayService } from '@clavisco/overlay';
import {RECAPTCHA_V3_SITE_KEY} from "ng-recaptcha";
import {environment} from "@Environment/environment";
import {ActionCenterPushInterceptor} from "@app/interceptors/action-center-push.interceptor";
import {KeybordInputDirective} from "@app/directives/keybord-input.directive";
import {FormsModule} from "@angular/forms";
import {KeyboardService} from "@app/services/keyboard.service";
import {Router} from "@angular/router";
import * as Sentry from "@sentry/angular-ivy";

/**
 * Providers de Sentry.
 *
 * Solo se registran cuando Sentry esta habilitado para el ambiente: en desarrollo
 * conviene conservar el ErrorHandler propio de Angular, que si imprime en consola.
 */
const SENTRY_PROVIDERS: Provider[] = environment.sentry.enabled ? [
  {
    // Captura todo error no manejado que llegue al ErrorHandler de Angular
    provide: ErrorHandler,
    useValue: Sentry.createErrorHandler({ logErrors: true })
  },
  {
    // Genera una transaccion de rendimiento por cada navegacion del Router
    provide: Sentry.TraceService,
    deps: [Router]
  },
  {
    // Fuerza la instanciacion del TraceService durante el arranque
    provide: APP_INITIALIZER,
    useFactory: () => () => {},
    deps: [Sentry.TraceService],
    multi: true
  }
] : [];

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    SharedModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AlertsModule,
    LoginModule,
    FormsModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: UrlInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HeadersInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: Miscellaneous.Interceptors.HttpAlertInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ActionCenterPushInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true
    },
    {
      provide: 'OverlayService',
      useClass: OverlayService
    },
    {
      provide: 'AlertsService',
      useClass: AlertsService
    },
    {
      provide: 'LinkerService',
      useClass: LinkerService
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: Miscellaneous.Interceptors.HttpAlertInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: Miscellaneous.Interceptors.PagedRequestInterceptor,
      multi: true
    },
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: environment.recatchaSiteKey
    },
    [KeyboardService],
    SENTRY_PROVIDERS,

  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
